/**
 * @file Thunder
 */
import extend from './extend';


const obj2query = (obj = {}) => {
    if (!obj) {
        return '';
    }
    let query = '';
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            let value = obj[key];
            if (value == null) {
                value = '';
            }
            else if (typeof value === 'object') {
                value = encodeURIComponent(JSON.stringify(value));
            }
            query += '&' + key + '=' + value;
        }
    }
    return query.slice(1);
};

const logUrl = (url = '', params = {}) => {
    return url + (~url.indexOf('?') ? '&' : '?') + obj2query(params);
};

const getParams = (base, params) => {
    let logExtra = extend({}, base.logExtra, params.logExtra);
    let obj = extend({}, base, params);
    obj.logExtra = logExtra;
    return obj;
};

const createImg = src => {
    let img = document.createElement('img');
    img.width = 1;
    img.height = 1;
    img.src = src;
    return img;
};

export class Thunder {
    constructor(opt = {}) {
        this.baseUrl = opt.url || 'https://hpd.baidu.com/v.gif';
        this.params = opt.params || {};
    }
    send(data, callback) {
        const params = getParams(this.params, data);
        const url = logUrl(this.baseUrl, params);
        let img = createImg(url);
        let isCallbacked = false;
        img.onload = img.onerror = args => {
            img = null;
            // 上报成功后，如果回调函数还没有执行，就执行回调函数
            if (callback && !isCallbacked) {
                callback(args);
                isCallbacked = true;
            }
        };
    }
}

let thunder;

export const initThunder = data => {
    const {bsData} = data;
    thunder = new Thunder({
        params: {
            ct: 2,
            logFrom: 'recdetail',
            logid: bsData.logid || '0',
            ssid: bsData.ssid || '0',
            sid: bsData.sid || '0',
            curRid: bsData.nid || '0',
            logExtra: {
                rid: bsData.nid,
                pos: 0,
                extra: '',
                isBaijiahao: bsData.isBaiJiaHao,
                login: bsData.header && bsData.header.islogin
            }
        }
    });
};

export const getThunder = () => thunder
                    || {send: args => {
                        // eslint-disable-next-line no-console
                        console.error('Thunder not init:', args);
                    }};
